import React, { Component, Fragment } from 'react';
import { withNamespaces } from 'react-i18next';
import { withStyles } from '@material-ui/core/styles';
import { withApollo } from 'react-apollo';
import classnames from 'classnames';

import PermitButton from '../../components/Global/Buttons/PermitButton';
import { AppContext } from '../../AppProvider';
import ShipmentLocation from '../../components/shipment/Location';
import ShipmentBasicInfoSection from '../../components/shipment/BasicInfoSection';
import ShipmentActivity from '../../components/shipment/Activity/Activity';
import ShipmentReferences from '../../components/shipment/References';
//import ShipmentDocuments from '../../components/shipment/Documents';
import ShipmentRate from '../../components/shipment/Rate';
//import ShipmentHeader from '../../components/shipment/ShipmentHeader';
//import ShipmentBillingInfo from '../../components/shipment/BillingInfo';
import ShipmentComments from '../../components/shipment/Comments/Comments';
import ShipmentStatus from '../../components/shipment/Status/Status';
import ShipmentBOLInstructions from '../../components/shipment/BOLInstructions';
import ShipmentEquipment from '../../components/shipment/Equipment';
import ShipmentServices from '../../components/shipment/Services';
import ShipmentContents from '../../components/shipment/Contents';
import ConfirmDialogModal from '../../components/Global/Modals/ConfirmDialog';
import * as Queries from '../../graphQL/queries/shipmentQueries';
import * as Mutations from '../../graphQL/mutations/shipmentMutations';
import { parseErrors } from '../../utils/queryHelpers';
import ErrorNotification from '../../components/common/ErrorNotification';
import LoadingIndicator from '../../components/LoadingIndicator';
import _last from 'lodash/last';
import _get from 'lodash/get';
import DateTimeUtils from '../../utils/DateTime';
import ShipmentUtils, { showEquipment } from '../../utils/Shipment';
import { Notifications, EmptyNotification } from './ShipmentDetails.mock';
import combineStyles from '../../utils/combineStyles';
import ShipmentDetailsStyles from './__styles__/ShipmentDetails.styles';
import LayoutStyles from '../../styles/layout';
import ButtonStyles from '../../styles/button';
import TypographyStyles from '../../styles/typography';
import SpacingHelperStyles from '../../styles/helpers/spacing';
import ShipmentMap from '../../components/shipment/ShipmentMap';
import MapModal from '../../components/Global/Modals/Maps';
import MapModalError from '../../components/Global/Modals/MapError';
import { getLocationContactDropdowns, formatBillToInfo } from './helpers';
import Grid from '@material-ui/core/Grid';
import FormItemContainer from '../../components/Global/Containers/FormItemContainer';
import Documents from './../../components/shipment/form/Documents';
import BillingInfo from '../../components/shipment/form/BillingInfo';
import Tracking from './../../components/shipment/Tracking/Tracking';
import {
  BILL_TO,
  SHIPMENT_STATUS,
  ERROR_SEVERITY
} from '../../constants/constants';
import { SHIPMENT_SAVE } from '../../constants/permissions';
import { isPermissible } from '../../components/Global/PermissionResolver';
import ViewToggle from '../../components/viewToggle/viewToggle';
import * as CancellationReasons from '../../graphQL/queries/orgRefShipmentCancellationReason';

const DISPLAY_DETAILS = 'details';
const DISPLAY_MAP = 'map';
export class ShipmentDetails extends Component {
  state = {
    displaySection: this.props.match.url.includes('map')
      ? DISPLAY_MAP
      : DISPLAY_DETAILS,
    showMapPoints: 'all',
    openEditBillingInfoModal: false,
    openNotificationFormModal: false,
    openConfirmDeleteNotificationModal: false,
    notifications: [...Notifications],
    notification: {
      ...EmptyNotification
    },
    loading: true,
    error: null,
    errors: null,
    shipment: null,
    hazMatClasses: [],
    hazMatPackingGroups: [],
    freightClasses: [],
    locations: [],
    contacts: [],
    displayOriginMap: false,
    displayDestinationMap: false,
    cancellationReasons: [],
    shipmentId: _get(this.props, 'match.params.id', null)
  };

  async componentDidMount() {
    await this._getData();
    const cancellationReasons = await this._getCancellationReasons();
    this.setState({ cancellationReasons });
  }
  _manuallyTenderShipment = async updatedValues => {
    const { client: ApolloClient } = this.props;
    const { shipment } = this.state;
    const updatedShipment = {
      shipmentId: shipment.id,
      rowVersion: shipment.rowVersion,
      ...updatedValues
    };
    try {
      await ApolloClient.mutate({
        mutation: Mutations.markAsTenderedMutation,
        variables: {
          manualTender: updatedShipment
        }
      });
      await this._getData();
      return true;
    } catch (error) {
      this.setState({ error });
      return false;
    }
  };

  // TODO: Duplicated in ShipmentForm.js
  _autotenderShipment = async (shipment, autoTender) => {
    const { client: ApolloClient } = this.props;
    const response = await ApolloClient.mutate({
      mutation: Mutations.tenderShipmentMutation,
      // Set error policy because tender is a 2-step process.
      // The save could success while the tender fails
      errorPolicy: 'all',
      variables: {
        shipment: { ...shipment },
        attemptAutoTender: autoTender
      }
    });

    const {
      data: {
        shipment: {
          tender: { id }
        }
      },
      errors
    } = response;

    const errs = parseErrors(errors);
    if (errs.severity >= ERROR_SEVERITY.Error) {
      throw new Error({ errors });
    }

    return { id, errs };
  };

  _saveWaitingPickup = async updatedValues => {
    const { client: ApolloClient } = this.props;
    const {
      shipment: { id: shipmentId, rowVersion }
    } = this.state;

    try {
      await ApolloClient.mutate({
        mutation: Mutations.markPickedUpMutation,
        variables: {
          manualPickup: { shipmentId, rowVersion, ...updatedValues }
        }
      });
      await this._getData();
      return true;
    } catch (error) {
      this.setState({ error });
      return false;
    }
  };
  _saveDelivered = async updatedValues => {
    const { client: ApolloClient } = this.props;
    const {
      shipment: { id: shipmentId, rowVersion }
    } = this.state;

    try {
      await ApolloClient.mutate({
        mutation: Mutations.markShipmentDelivered,
        variables: {
          manualDelivered: { shipmentId, rowVersion, ...updatedValues }
        }
      });
      await this._getData();
      return true;
    } catch (error) {
      this.setState({ error });
      return false;
    }
  };
  _updateShipment = async updatedValues => {
    const { client: ApolloClient } = this.props;
    const { shipment } = this.state;
    const orgId = shipment.orgId;
    const rowVersion = shipment.rowVersion;
    // {"data":{"shipment":{"save":{"rowVersion"
    try {
      await ApolloClient.mutate({
        mutation: Mutations.saveShipmentMutation,
        variables: {
          shipment: {
            orgId: orgId,
            id: shipment.id,
            rowVersion: rowVersion,
            ...updatedValues
          }
        }
      });
      await this._getData();
      return true;
    } catch (error) {
      this.setState({ error });
      return false;
    }
  };
  _handleDeleteShipment = async () => {
    const { client: ApolloClient } = this.props;
    const { shipment } = this.state;

    try {
      await ApolloClient.mutate({
        mutation: Mutations.deleteShipment,
        variables: {
          shipment: { shipmentId: shipment.id, ignoreWarnings: true }
        }
      });
      return true;
    } catch (error) {
      this.setState({ error });
      return false;
    }
  };
  _handlePlannedDateUpdate = async stop => {
    const { client: ApolloClient } = this.props;
    const {
      shipment: { id: shipmentId, rowVersion }
    } = this.state;
    try {
      await ApolloClient.mutate({
        mutation: Mutations.updateStopPlannedTimeWindow,
        variables: {
          stopTimeWindow: {
            ignoreWarnings: true,
            shipmentId,
            rowVersion,
            ...stop
          }
        }
      });
      await this._getData();
      return true;
    } catch (error) {
      this.setState({ error });
      return false;
    }
  };
  _handleShipmentException = async exception => {
    const { client: ApolloClient } = this.props;
    const {
      shipment: { id: shipmentId, rowVersion }
    } = this.state;
    try {
      await ApolloClient.mutate({
        mutation: Mutations.markException,
        variables: {
          exception: {
            shipmentId,
            rowVersion,
            shipmentExceptionReasonNotes: exception.shipmentExceptionReasonNotes
          }
        }
      });
      await this._getData();
      return true;
    } catch (error) {
      this.setState({ error });
      return false;
    }
  };
  _handleShipmentCancel = async cancellationInfo => {
    const { client: ApolloClient } = this.props;
    const {
      shipment: { id: shipmentId, rowVersion }
    } = this.state;
    try {
      await ApolloClient.mutate({
        mutation: Mutations.cancelShipment,
        variables: {
          shipment: {
            shipmentId,
            rowVersion,
            ignoreWarnings: true,
            ...cancellationInfo
          }
        }
      });
      await this._getData();
      return true;
    } catch (error) {
      this.setState({ error });
      return false;
    }
  };

  _handleActualDateUpdate = async stop => {
    const { client: ApolloClient } = this.props;
    const {
      shipment: { id: shipmentId, rowVersion }
    } = this.state;
    try {
      await ApolloClient.mutate({
        mutation: Mutations.updateStopActualTimes,
        variables: {
          updateStopActualTimes: {
            shipmentId,
            rowVersion,
            ...stop
          }
        }
      });
      await this._getData();
      return true;
    } catch (error) {
      this.setState({ error });
      return false;
    }
  };
  _resumeShipment = async () => {
    const { client: ApolloClient } = this.props;
    const { shipment } = this.state;
    this.setState({ loading: true });
    const rowVersion = shipment.rowVersion;
    const resumeStatuses = {
      [SHIPMENT_STATUS.WAITING_FOR_PICKUP]: {
        variable: 'manualTender',
        mutation: Mutations.markAsTenderedMutation
      },
      [SHIPMENT_STATUS.IN_TRANSIT]: {
        variable: 'manualPickup',
        mutation: Mutations.markPickedUpMutation
      },
      [SHIPMENT_STATUS.DELIVERED]: {
        variable: 'manualDelivered',
        mutation: Mutations.markShipmentDelivered
      }
    };
    const status = resumeStatuses[shipment.previousShipmentStatusId];
    try {
      await ApolloClient.mutate({
        mutation: status.mutation,
        variables: {
          [status.variable]: {
            shipmentId: parseInt(shipment.id),
            rowVersion: rowVersion
          }
        }
      });
      await this._getData();
      return true;
    } catch (error) {
      this.setState({
        error
      });
      return false;
    }
  };
  _reverseShipmentStatus = async () => {
    const { client: ApolloClient } = this.props;
    const { shipment } = this.state;
    this.setState({ loading: true });
    const rowVersion = shipment.rowVersion;
    const reverseStatuses = {
      [SHIPMENT_STATUS.WAITING_FOR_PICKUP]: {
        variable: 'cancelTender',
        mutation: Mutations.cancelTender
      },
      [SHIPMENT_STATUS.IN_TRANSIT]: {
        variable: 'manualTender',
        mutation: Mutations.markAsTenderedMutation
      },
      [SHIPMENT_STATUS.DELIVERED]: {
        variable: 'manualPickup',
        mutation: Mutations.markPickedUpMutation
      }
    };
    const status = reverseStatuses[shipment.shipmentStatusId];

    try {
      await ApolloClient.mutate({
        mutation: status.mutation,
        variables: {
          [status.variable]: {
            shipmentId: parseInt(shipment.id),
            rowVersion: rowVersion
          }
        }
      });
      // this.setState({ loading: false });
      await this._getData();
      return true;
    } catch (error) {
      console.log(error);
      this.setState({
        error,
        loading: false
      });
      return false;
    }
  };
  _getData = async () => {
    const {
      match: {
        params: { id }
      },
      client: ApolloClient,
      history
    } = this.props;

    try {
      this.setState({ loading: true });
      const {
        referenceData: { hazMatClasses, hazMatPackingGroups, freightClasses },
        currentOrgId
      } = this.context.globalProps;

      const {
        data: {
          shipment: { byId: shipment }
        }
      } = await ApolloClient.query({
        query: Queries.shipmentById,
        variables: { id },
        fetchPolicy: 'network-only',
        skip: true
      });
      if (shipment.shipmentStatusId === SHIPMENT_STATUS.SAVED) {
        history.push(`/shipments/${id}/edit`);
      }
      const {
        data: {
          shipment: {
            activityLog: { activityLogDetails: activityLog }
          }
        }
      } = await ApolloClient.query({
        query: Queries.shipmentActivityLog,
        variables: { id },
        fetchPolicy: 'network-only'
      });
      shipment.activityLog = activityLog;

      const {
        data: {
          shipment: { commentSubscribersByShipment: commentSubscribers }
        }
      } = await ApolloClient.query({
        query: Queries.shipmentCommentSubscribers,
        variables: { shipmentId: id },
        fetchPolicy: 'network-only'
      });
      shipment.commentSubscribers = commentSubscribers;

      const locationDropdowns = await getLocationContactDropdowns(
        ApolloClient,
        currentOrgId
      );
      this.setState({
        hazMatClasses,
        hazMatPackingGroups,
        shipment,
        freightClasses,
        locations: _get(locationDropdowns, 'locations', []),
        contacts: _get(locationDropdowns, 'contacts', [])
      });
    } catch (error) {
      this.setState({
        error
      });
    } finally {
      this.setState({
        loading: false
      });
    }
  };

  async componentDidUpdate(prevProps) {
    if (
      _get(prevProps, 'match.params.id') !== _get(this.props, 'match.params.id')
    ) {
      await this._getData();
    }
  }

  handleOpenEditBillingInfoModal = () => {
    this.setState({ openEditBillingInfoModal: true });
  };

  _handleCloseEditBillingInfoModal = () => {
    this.setState({ openEditBillingInfoModal: false });
  };

  _handleUpdateBillingInfo = async values => {
    const { shipment } = this.state;
    if (values.billTo === BILL_TO.THIRD_PARTY) {
      await this._updateShipment({ billToInfo: values });
    } else {
      const stops = {
        [BILL_TO.SHIPPER]: shipment.pickup,
        [BILL_TO.CONSIGNEE]: shipment.delivery
      };

      const billToInfo = formatBillToInfo(values, stops[values.billTo]);
      await this._updateShipment({ billToInfo });
    }

    this._handleCloseEditBillingInfoModal();
  };

  _handleOpenNotificationFormModal = notificationId => {
    const { notifications } = this.state;
    let notification = notifications.find(
      notification => notification.id === notificationId
    );

    if (!notification) {
      notification = {
        ...EmptyNotification
      };
    }

    this.setState({ notification }, () => {
      this.setState({ openNotificationFormModal: true });
    });
  };

  _handleCloseNotificationFormModal = () => {
    this.setState({ openNotificationFormModal: false });
  };
  _handleUpdateTracking = emails => {
    const { shipment } = this.state;
    shipment.trackingNotificationEmailAddresses = emails;
    this.setState({ shipment });
  };
  _handleSaveNotificationRecipient = notificationRecipient => {
    let { notifications } = this.state;
    if (notificationRecipient.id) {
      notifications = notifications.map(notification => {
        if (notification.id === notificationRecipient.id) {
          return notificationRecipient;
        }
        return notification;
      });
    } else {
      notifications.push({
        ...notificationRecipient,
        id: notifications.length + 1
      });
    }

    this.setState(
      {
        notifications: [...notifications]
      },
      () => {
        this._handleCloseNotificationFormModal();
      }
    );
  };

  _handleRemoveNotificationRecipient = notificationRecipientId => {
    const { notifications } = this.state;
    this.setState(
      {
        notifications: [
          ...notifications.filter(
            notification => notification.id !== notificationRecipientId
          )
        ]
      },
      () => {
        this._handleCloseConfirmDeleteNotificationModal();
        this._handleCloseNotificationFormModal();
      }
    );
  };

  _handleOpenConfirmDeleteNotificationModal = () => {
    this.setState({ openConfirmDeleteNotificationModal: true });
  };

  _handleCloseConfirmDeleteNotificationModal = () => {
    this.setState({ openConfirmDeleteNotificationModal: false });
  };
  _getCancellationReasons = async () => {
    const { client: ApolloClient } = this.props;
    const { currentOrgId } = this.context.globalProps;

    try {
      const {
        data: {
          orgRef_ShipmentCancellationReason: { all }
        }
      } = await ApolloClient.query({
        query: CancellationReasons.all,
        variables: { orgId: currentOrgId, includeExpired: false }
      });

      return all;
    } catch (error) {
      this.setState({ error });
      return false;
    }
  };
  _handleOnTagDocument = () => {};

  _handleOnDeleteDocument = () => {};
  handleMapModalClick = mapName => {
    this.setState({ [mapName]: true });
  };
  handleMapModalClose = mapName => {
    this.setState({ [mapName]: false });
  };
  _handleCommentUpdate = async () => {
    const { client: ApolloClient } = this.props;
    const { shipment } = this.state;
    try {
      const {
        data: {
          shipment: { byId: shipmentData }
        }
      } = await ApolloClient.query({
        fetchPolicy: 'network-only',
        skip: true,
        query: Queries.commentsByShipmentId,
        variables: { id: shipment.id }
      });
      shipment.comments = shipmentData.comments;
      this.setState({ shipment });
    } catch (error) {
      this.setState({ error });
    }
  };
  editButton = canEditShipment => {
    const { classes, t, history } = this.props;
    const { shipmentId } = this.state;
    if (!canEditShipment) {
      return '';
    }
    return (
      <PermitButton
        className={classnames(classes.button, classes.editButton)}
        onClick={() => {
          history.push(`/shipments/${shipmentId}/edit`);
        }}
        color={'primary'}
        variant={'text'}
        disableRipple={true}
        classes={{
          label: classes.buttonLabelSecondaryAction,
          root: classes.buttonRoot
        }}
        permission={SHIPMENT_SAVE}
      >
        {t('Edit')}
      </PermitButton>
    );
  };
  _handleErrorOnClose = () => {
    this.setState({ errors: null });
  };
  _handlePageDisplaySection = displaySection => {
    this.setState({ displaySection });
  };
  _isShipmentEditable = () => {
    const { shipment } = this.state;
    return (
      isPermissible(this.context.globalProps, SHIPMENT_SAVE) &&
      _get(shipment, 'shipmentStatusId', '') !== SHIPMENT_STATUS.CANCELLED
    );
  };
  render() {
    const { classes, t, history } = this.props;
    const {
      loading,
      error,
      shipment,
      hazMatClasses,
      hazMatPackingGroups,
      displayOriginMap,
      displayDestinationMap,
      displaySection,
      locations,
      contacts,
      cancellationReasons
    } = this.state;
    const canEditShipment = this._isShipmentEditable();

    if (loading) {
      return <LoadingIndicator />;
    }

    if (error) {
      return <ErrorNotification message="Error loading page" />;
    }

    shipment.pickup = shipment.stops[0];
    shipment.delivery = _last(shipment.stops);

    return (
      <Fragment>
        <ConfirmDialogModal
          open={this.state.openConfirmDeleteNotificationModal}
          title={t('Are you sure you want to remove this recipient?')}
          message={`${this.state.notification.user} ${t(
            'will no longer receive any notifications for this shipment.'
          )}`}
          confirmLabel={t('Delete')}
          onClose={this._handleCloseConfirmDeleteNotificationModal}
          onConfirm={() =>
            this._handleRemoveNotificationRecipient(this.state.notification.id)
          }
        />

        <div className={classes.toolbarRoot}>
          <h1 className={classes.headline4}>
            {t('Shipment')} #{shipment.id}
          </h1>
          <ViewToggle
            detailIcon="detail"
            primarySelected={displaySection === DISPLAY_DETAILS ? true : false}
            onPrimaryClick={() => {
              this._handlePageDisplaySection(DISPLAY_DETAILS);
            }}
            onSecondaryClick={() => {
              this._handlePageDisplaySection(DISPLAY_MAP);
            }}
          />
        </div>
        <div
          className={classnames({
            [classes.hidden]: displaySection === DISPLAY_DETAILS
          })}
        >
          {displaySection !== DISPLAY_DETAILS && (
            <ShipmentMap shipment={shipment} />
          )}
        </div>
        <Grid
          container
          spacing={16}
          classes={{
            container: classnames({
              [classes.hidden]: displaySection === DISPLAY_MAP
            })
          }}
        >
          <Grid item lg={12}>
            <ShipmentStatus
              shipment={shipment}
              onShipmentTender={this._manuallyTenderShipment}
              onShipmentWaitingPickup={this._saveWaitingPickup}
              onShipmentDelivered={this._saveDelivered}
              onUpdate={this._updateShipment}
              onShipmentResume={this._resumeShipment}
              onPlannedDateUpdate={this._handlePlannedDateUpdate}
              onActualDateUpdate={this._handleActualDateUpdate}
              onReverseShipmentStatus={this._reverseShipmentStatus}
              onShipmentException={this._handleShipmentException}
              onDeleteShipment={this._handleDeleteShipment}
              onCancelShipment={this._handleShipmentCancel}
              onAutoTenderShipment={this._autotenderShipment}
              editable={canEditShipment}
              history={history}
              cancellationReasons={cancellationReasons}
              isAuthenticated={true}
            />
          </Grid>
          <Grid item lg={3}>
            <Documents
              values={{ id: shipment.id, files: shipment.shipmentFiles }}
              shipment={shipment}
              editable={canEditShipment}
            />
            <Tracking
              shipmentId={shipment.id}
              orgId={shipment.orgId}
              rowVersion={shipment.rowVersion}
              emailAddresses={shipment.trackingNotificationEmailAddresses}
              onUpdate={this._handleUpdateTracking}
              shipmentStatusId={shipment.shipmentStatusId}
              editable={canEditShipment}
            />
            <BillingInfo
              billToInfo={shipment.billToInfo}
              onUpdate={this._handleUpdateBillingInfo}
              locations={locations}
              contacts={contacts}
              isNewShipment={false}
              editable={canEditShipment}
            />
          </Grid>
          <Grid item lg={6}>
            <FormItemContainer
              title={t('Shipment Details')}
              secondaryAction={this.editButton(canEditShipment)}
            >
              <ShipmentBasicInfoSection shipment={shipment} />
              <div className={classes.contentDividerInt} />
              <ShipmentLocation
                locationType={t('Pickup')}
                locationName={shipment.pickup.locationName}
                locationAddress={shipment.pickup.locationAddress.address1}
                locationStateInfo={ShipmentUtils.formatAddress(
                  shipment.pickup.locationAddress
                )}
                locationDockTime={`${t(
                  'Dock Times'
                )}: ${DateTimeUtils.midnightSecondsToHour(
                  shipment.pickup.openFromTimeLocal
                )} - ${DateTimeUtils.midnightSecondsToHour(
                  shipment.pickup.openToTimeLocal
                )}`}
                firstName={shipment.pickup.contactInfo.firstName}
                lastName={shipment.pickup.contactInfo.lastName}
                contactPhone={shipment.pickup.contactInfo.phone}
                contactEmail={shipment.pickup.contactInfo.email}
                notes={shipment.pickup.pickupNotes || '-'}
                onMapClick={() => {
                  this.handleMapModalClick('displayOriginMap');
                }}
              />
              {_get(shipment, 'pickup.locationAddress.lat') &&
              _get(shipment, 'pickup.locationAddress.long') ? (
                <MapModal
                  open={displayOriginMap}
                  mapName={'originMap'}
                  address={_get(shipment, 'pickup.locationAddress')}
                  onConfirm={() => {
                    this.handleMapModalClose('displayOriginMap');
                  }}
                />
              ) : (
                <MapModalError
                  open={displayOriginMap}
                  onConfirm={() => {
                    this.handleMapModalClose('displayOriginMap');
                  }}
                />
              )}
              <div className={classes.contentDividerInt} />
              <ShipmentLocation
                locationType={t('Delivery')}
                locationName={shipment.delivery.locationName}
                locationAddress={shipment.delivery.locationAddress.address1}
                locationStateInfo={ShipmentUtils.formatAddress(
                  shipment.delivery.locationAddress
                )}
                locationDockTime={`${t(
                  'Dock Times'
                )}: ${DateTimeUtils.midnightSecondsToHour(
                  shipment.delivery.openFromTimeLocal
                )} - ${DateTimeUtils.midnightSecondsToHour(
                  shipment.delivery.openToTimeLocal
                )}`}
                firstName={shipment.delivery.contactInfo.firstName}
                lastName={shipment.delivery.contactInfo.lastName}
                contactPhone={shipment.delivery.contactInfo.phone}
                contactEmail={shipment.delivery.contactInfo.email}
                notes={shipment.delivery.deliveryNotes || '-'}
                onMapClick={() => {
                  this.handleMapModalClick('displayDestinationMap');
                }}
              />
              {_get(shipment, 'delivery.locationAddress.lat') &&
              _get(shipment, 'delivery.locationAddress.long') ? (
                <MapModal
                  open={displayDestinationMap}
                  mapName={'destinationMap'}
                  address={_get(shipment, 'delivery.locationAddress')}
                  onConfirm={() => {
                    this.handleMapModalClose('displayDestinationMap');
                  }}
                />
              ) : (
                <MapModalError
                  open={displayDestinationMap}
                  onConfirm={() => {
                    this.handleMapModalClose('displayDestinationMap');
                  }}
                />
              )}
              <div className={classes.contentDividerInt} />
              <ShipmentContents
                shipment={shipment}
                hazMatClasses={hazMatClasses}
                hazMatPackingGroups={hazMatPackingGroups}
              />
              <div className={classes.contentDividerInt} />
              <Grid container spacing={16}>
                <Grid item lg={showEquipment(shipment.shipmentModeId) ? 6 : 12}>
                  <ShipmentServices shipment={shipment} />
                </Grid>
                {showEquipment(shipment.shipmentModeId) && (
                  <Grid item lg={6}>
                    <ShipmentEquipment shipment={shipment} />
                  </Grid>
                )}
              </Grid>
              <div className={classes.contentDividerInt} />
              <ShipmentReferences references={shipment.references} />
              <div className={classes.contentDividerInt} />
              <div className={classes.titleRootWrapper}>
                <h2 className={classes.headline7}>{t('Rate')}</h2>
              </div>
              <ShipmentRate shipment={shipment} />
              <div className={classes.contentDividerInt} />
              <ShipmentBOLInstructions shipment={shipment} />
            </FormItemContainer>
          </Grid>
          <Grid item lg={3}>
            <ShipmentComments
              shipmentId={shipment.id}
              comments={shipment.comments}
              subscribers={shipment.commentSubscribers}
              onUpdate={this._handleCommentUpdate}
            />
            <ShipmentActivity activities={shipment.activityLog} />
          </Grid>
        </Grid>
      </Fragment>
    );
  }
}

ShipmentDetails.contextType = AppContext;
const translatedShipmentDetails = withNamespaces()(ShipmentDetails);

export default withStyles(
  combineStyles(
    LayoutStyles,
    TypographyStyles,
    ButtonStyles,
    SpacingHelperStyles,
    ShipmentDetailsStyles
  )
)(withApollo(translatedShipmentDetails));
